import { setCookie, eraseCookie, getCookie } from "../utils/cookies";

export default () => {
  let cookieName = "alert-timedout";
  let cookieDurationInDays = 1;
  let container = document.querySelector(".alert-bar");
  if (!container) return; // bail out if the container doesn't exist
  let closeModalButton = container.querySelector("button");
  let showContainer = !getCookie(cookieName); // only show it if the timeout cookie does not exist

  if (showContainer) {
    setTimeout(function () {
      container.classList.add("open");
    }, 100);
  }

  closeModalButton.addEventListener("click", function (e) {
    e.preventDefault();
    setCookie(cookieName, true, cookieDurationInDays);
    container.classList.remove("open");
  });
};
